export class ErrorResponseNode {

    errorCode: string;
    errorMsg: string;
    params: any;

    constructor( errorCode: string, errorMsg: string, params: any ) {
        this.errorCode = errorCode;
        this.errorMsg = errorMsg;
        this.params = params;
    }
}
